export enum FeedbackType {
  BUG = 'BUG',
  FEATURE_REQUEST = 'FEATURE_REQUEST',
  IMPROVEMENT = 'IMPROVEMENT',
  OTHER = 'OTHER'
}

export enum FeedbackPriority {
  LOW = 'LOW',
  MEDIUM = 'MEDIUM',
  HIGH = 'HIGH',
  CRITICAL = 'CRITICAL'
}

export enum FeedbackStatus {
  NEW = 'NEW',
  IN_PROGRESS = 'IN_PROGRESS',
  RESOLVED = 'RESOLVED',
  REJECTED = 'REJECTED',
  DUPLICATE = 'DUPLICATE'
}

export interface FeedbackRequest {
  type: string;
  title: string;
  description: string;
  priority?: string;
  teamId?: string;
  url?: string;
  userAgent?: string;
  browserInfo?: string;
  screenshotUrl?: string;
}

export interface Feedback {
  id: string;
  type: string;
  title: string;
  description: string;
  priority: string;
  status: string;
  userId?: string;
  userName?: string;
  teamId?: string;
  teamName?: string;
  url?: string;
  userAgent?: string;
  browserInfo?: string;
  screenshotUrl?: string;
  adminNotes?: string;
  createdAt: string;
  updatedAt?: string;
}
